import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CustomTable from "../../common/CustomTable";
import { useSelector, useDispatch } from "react-redux";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchUserPoints,
  selectUserPoints,
  fetchMoreUserPoints,
  getFullList,
} from "./userPointsSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchUserPointUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function UserPointsContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [userpointNames, setUserPointNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");

  const {
    userpoints,
    error,
    loading,
    userPointsList,
    userPointsAmount,
    lastQuery,
  } = useSelector(selectUserPoints);

  const { clients, clientsList } = useSelector(selectClients);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [client, setClient] = useState("");

  const urlParams = new URLSearchParams(window.location.search);

  const invoiceParam = urlParams.get("invoice");
  // const clientParam = urlParams.get('client');

  // useEffect(() => {
  //   dispatch(
  //     fetchUserPoints({
  //       token: jwtToken,
  //       query: `invoiceid=${invoiceParam != null ? invoiceParam : ""}&limit=500&sort=desc`,
  //     })
  //   );
  // }, [invoiceParam])

  const headCells = [
    {
      id: "userID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User #",
      long: false,
      sortable: true,
    },
    {
      id: "userDisplayName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member",
      long: true,
      sortable: true,
    },
    {
      id: "userEmail",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Email",
      long: false,
      sortable: true,
    },
    {
      id: "redeemablePoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Redeemable Points",
      long: true,
      sortable: true,
    },
    {
      id: "purchasedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Purchased Points",
      long: true,
      sortable: true,
    },
    {
      id: "expiredPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Expired Points",
      long: true,
      sortable: true,
    },
    {
      id: "pendingPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Pending Points",
      long: true,
      sortable: true,
    },
    {
      id: "redeemedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Redeemed Points",
      long: true,
      sortable: true,
    },
    {
      id: "declinedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Declined Points",
      long: true,
      sortable: true,
    },
    {
      id: "redundedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Redunded Points",
      long: true,
      sortable: true,
    },
    {
      id: "totalPointsEarned",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Total Points Earned",
      long: true,
      sortable: true,
    },
    // {
    //   id: "invoicesByUserPoint",
    //   checked: true,
    //   numeric: false,
    //   disablePadding: false,
    //   label: "View Related Invoice",
    //   long: false,
    // },
  ];

  const handleUserPointsChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedUserPoint = userPointsList.filter(
      (userpoint) => userpoint.userpointNumber === event.target.value
    );
    selectedUserPoint && idsArr.push(selectedUserPoint[0].id);
    // });

    setUserPointNames(event.target.value);
    setUserIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  useEffect(() => {
    dispatch(fetchClients({ token: jwtToken, query: "" }));
  }, []);

  const handleChange = (event) => {
    setClient(event.target.value);
    let searchQuery = `?limit=${rowsPerPage}`;

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    if (invoiceParam) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", rowsPerPage);
    }

    // searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

    dispatch(
      fetchUserPoints({
        token: jwtToken,
        query: searchQuery,
        clientID: event.target.value,
        // query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  };

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > userPointsList.length
            ? rowsPerPage
            : userPointsList.length,
        query: searchQuery,
        targetLength: userPointsAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        userPointsList.length < userPointsAmount &&
        userPointsList.length < expectedLen
      ) {
        dispatch(
          fetchMoreUserPoints({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
            clientID: client,
          })
        );
      } else if (userPointsList.length == userPointsAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "up.updated_at";
        break;
      case "createdAt":
        property = "up.created_at";
        break;
      case "statusID":
        property = "up.status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "userID":
        property = "u.id";
        break;
      case "userEmail":
        property = "u.email";
        break;
      case "userDisplayName":
        property = "u.display_name";
        break;
      case "redeemablePoints":
        property = "redeemable";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchUserPoints({
        token: jwtToken,
        query: searchQuery,
        clientID: client,
      })
    );
  };

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchUserPoints({
        query: searchQuery,
        token: jwtToken,
        clientID: client,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setUserPointNames([]);
    setUserIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setDateAfter("");
    setDateBefore("");
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchUserPoints({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
        clientID: client,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = [];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={userPointsList}
        actionsLists={[]}
        actionsHandleChange={[]}
        actionsNames={[]}
        headCells={headCells}
        cellList={cellList}
        // handleSearch={handleSearch}
        handleClear={handleClear}
        area={"userpoint"}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={userPointsAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLleft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </Grid>

      {content}
    </Grid>
  );
}
